import gql from 'graphql-tag';

export const GET_PICKER_DAILY_STATS = gql`
	query getPickerDailyStats($date: String, $pickerId: ID) {
		getPickerDailyStats(date: $date, pickerId: $pickerId) {
			picker {
				id
				firstname
				lastname
			}
			date
			today {
				posCount
				units
				pickingTimeMilliseconds
				averageTimePerPOSMilliseconds
				averageTimePer100UnitsMilliseconds
			}
			last30Days {
				posCount
				units
				pickingTimeMilliseconds
				averageTimePerPOSMilliseconds
				averageTimePer100UnitsMilliseconds
				activeDayCount
				averageUnitsPerActiveDay
			}
		}
	}
`;

export const RECALCULATE_MACHINE_PICKLIST = gql`
	mutation recalculatePickList (
		$pickListId: ID!,
	) {
		recalculatePickList (
			pickListId: $pickListId,
		) {
			id
			calculatedAt

			serviceRun {
				id
			}
			serviceDocket {
				id
				cashBag
				tub
				isRestocked
			}
			machine {
				id
				type
				ingredientPlanogram {
					id
				}
				planogram {
					id
					planogramItemGroups {
						id
						name
						type
						order
						layoutSettings
					}
				}
			}
			pickListItems {
				id
				isPicked
				extraQuantityIsPicked
				pickOrder
				planogramItem {
					id
					selection
					inactive
					quantity
					parlevel
					capacity
					price
					reportedPrice
					enabled
					isIngredient
					row
					column
					queuedPrice
					queuedPriceType
					planogramItemGroupId
					planogramItemStatistics {
						id
						salesLast7Days
						salesLast14Days
						salesLast30Days
						salesLast365Days
						lastProductChangeTime	
					}
					created
				}
				selection

				quantity
				extraQuantity
				unadjustedQuantity

				planogramItemQuantity
				planogramItemParlevel
				planogramItemExpiryDatesAtPick

				originalPickQuantity
				originalPlanogramItemQuantity
				originalPickExtraQuantity
				lastCalculatedExtraQuantity

				product {
					id
					name
					audioName
					imageUrl
					HCGCategory
					HFDCategory
					weight
					measurementUnit
				}
				removedProduct {
					id
					name
					imageUrl
				}
			}
		}
	}
`;
